<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<header>
<h1 class="topictitle1" id="ep2"><a href="#/nav#nep2"><span class="first_text">Epigraph</span></a></h1>
</header>
<div class="epi_group">
<p class="epigraph">Socially inept, I was—like most of my friends, driven mostly by a child-like sense of wonder about the world. We were beat
               over the heads for our strange ideas—told that the answers we sought from nature were impossibilities . . . that we must put
               away childish thoughts, and curiosity, and “grow up.” Some of us resisted. We never did finish growing up. But we never stopped
               growing.
            </p>
<p class="epigraph_attribution">—Sir Arthur C. Clarke</p>
<p class="sep"> </p>
<p class="epigraph">It’s kind of fun to do the impossible.</p>
<p class="epigraph_attribution">—Walt Disney</p>
<p class="sep"> </p>
<p class="epigraph">1N73LL1G3NC3 15 7H3 4B1L17Y 70 4D4P7 70 CH4NG3.</p>
<p class="epigraph_attribution">—573PH3N H4WK1NG</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epigraph.vue?16823592